'use strict';
module.exports = function Offset(params) {
	if (!params || !Number.isFinite(params.x) || !Number.isFinite(params.y)) {
		throw new Error('invalid-args');
	}
	const {x, y} = params,
		add = function (offset) {
			return new Offset({
				x: x + offset.x,
				y: y + offset.y
			});
		},
		subtract = function (offset) {
			return new Offset({
				x: x - offset.x,
				y: y - offset.y
			});
		},
		multiply = function (offset) {
			return new Offset({
				x: x * offset.x,
				y: y * offset.y
			});
		},
		extension = () => Math.pow(x, 2) + Math.pow(y, 2);

	Object.freeze(Object.assign(this, {x, y, add, multiply, extension, subtract}));
};
